<template>
  <RouterViewer />
  <IdleModal v-if="userStore.username && !userStore.isWebshop" />
  <ImpersonationIndicator />
  <Toasts />
  <StickyPhoneWidget />
  <CookieConsent />
</template>
<script setup>
import { IdleModal } from "@/components/sign-in";
import { inject } from "vue";
import { useUserStore } from "@/store/user";
import brandconfig from "@/brandconfig";
import { ImpersonationIndicator } from "@xs2event/js-lib/impersonation";
import { Toasts } from "@xs2event/js-lib/toast";
import { useVersionChecker } from "@xs2event/js-lib/util";
import "@xs2event/js-lib/style";
import { api } from "@/helpers/api";
import RouterViewer from "@/pages/RouterViewer.vue";
import StickyPhoneWidget from "@/components/page/StickyPhoneWidget.vue";
import CookieConsent from "@/components/shared/CookieConsent.vue";
const userStore = useUserStore();

useVersionChecker({
  api,
  projectSlug: "xs2event-portal-v2",
});

userStore.init();

if (brandconfig.GA_ID) {
  inject("gtag");
}
</script>
